import { render, staticRenderFns } from "./filter_restaurant.vue?vue&type=template&id=af421f30&scoped=true&"
import script from "./filter_restaurant.vue?vue&type=script&lang=js&"
export * from "./filter_restaurant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af421f30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af421f30')) {
      api.createRecord('af421f30', component.options)
    } else {
      api.reload('af421f30', component.options)
    }
    module.hot.accept("./filter_restaurant.vue?vue&type=template&id=af421f30&scoped=true&", function () {
      api.rerender('af421f30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/restaurants/filter_restaurant.vue"
export default component.exports